// extracted by mini-css-extract-plugin
export var cookieLayoutWrapper = "cookie-module--cookie-layout-wrapper--caAYO";
export var cookieConsentContainer = "cookie-module--cookie-consent-container--yzgN9";
export var cookieConsentTextContainer = "cookie-module--cookie-consent-text-container--WsqNH";
export var cookieConsentButton = "cookie-module--cookie-consent-button--UqRHR";
export var cookieDeclineButton = "cookie-module--cookie-decline-button--p2UrR";
export var cookieIcon = "cookie-module--cookie-icon--JBsr+";
export var learnMore = "cookie-module--learn-more--D4NEV";
export var cookieConsentFloatIn = "cookie-module--cookie-consent-float-in--TymEU";
export var floating = "cookie-module--floating--8YRRg";